export default __webpack_public_path__ + "static/media/Regiane-Bueno.ad3921d9.png";